export default [
  {
    path: '/home',          //首页
    name: 'home',          //首页
    component: (resolve) => require(['@/views/home/home'], resolve),
    hidden: true,
    meta: {
      title: 'global.home_page',
      code:'mgr',
    },
    redirect: '/questionnaire_manage',
    children: [
      {
        path: 'questionnaire_manage',        // 量表管理
        name: 'questionnaire_manage',        // 量表管理
        component: resolve => require(['@/views/questionnaire_management/questionnaire_manage'], resolve),
        meta: {
          title: '量表管理',
          code:'scale_management',
        }
      },
      {
        path: 'patients_report_management',        // 患者报告
        name: 'patients_report_management',        // 患者报告
        component: resolve => require(['@/views/patients_report_management/patients_report_management'], resolve),
        meta: {
          title: '患者报告',
          code:'my_patient',
        }
      },
      {
        path: 'my_scale_management',        // 我的量表
        name: 'my_scale_management',        // 我的量表
        component: resolve => require(['@/views/my_scale_management/my_scale_management'], resolve),
        meta: {
          title: '我的量表',
          code:'my_scale',
        }
      },
      {
        path: 'patients_management',        // 患者管理
        name: 'patients_management',        // 患者管理
        component: resolve => require(['@/views/patients_management/patients_management'], resolve),
        meta: {
          title: '患者管理',
          code:'patient_management',
        }
      },
      {
        path: 'questionnaire_answer',        // 量表答卷
        name: 'questionnaire_answer',        // 量表答卷
        component: resolve => require(['@/views/questionnaire_answer_management/questionnaire_answer_management'], resolve),
        meta: {
          title: '量表答卷',
          code:'scale_answer_sheet',
        }
      },
      {
        path: 'package_management',        // 测评包管理
        name: 'package_management',        // 测评包管理
        component: resolve => require(['@/views/package_management/package_management'], resolve),
        meta: {
          title: '测评包管理',
          code:'package_management',
        }
      },
      {
        path: 'package_answer_management',        // 测评包答卷
        name: 'package_answer_management',        // 测评包答卷
        component: resolve => require(['@/views/package_answer_management/package_answer_management'], resolve),
        meta: {
          title: '测评包答卷',
          code:'package_answer_sheet',
        }
      },
      {
        path: 'user_management',        //用户管理
        name: 'user_management',        //用户管理
        component: resolve => require(['@/views/user_management/user_management'], resolve),
        meta: {
          title: 'global.users',
          code:'mgr',
        }
      },
      {
        path: 'label_manage',        //标签管理
        name: 'label_manage',        //标签管理
        component: resolve => require(['@/views/label_manage/label_manage'], resolve),
        meta: {
          title: 'global.users',
          code:'mgr',
        }
      },
      {
        path: 'role_management',         //角色管理
        name: 'role_management',         //角色管理
        component: resolve => require(['@/views/role_management/role_management'], resolve),
        meta: {
          title: 'global.roles',
          code:'role',
        }
      },
      {
        path: 'bed_management',//  床位信息
        name: 'bed_management',//  床位信息
        component: resolve => require(['@/views/bed_management/bed_management'], resolve),
        meta: {
          title: '床位信息',
          code: 'role',
        }
      },
      {
        path: 'dept_management',         //部门管理
        name: 'dept_management',         //部门管理
        component: resolve => require(['@/views/dept_management/dept_management'], resolve),
        meta: {
          title: 'global.depts',
          code:'dept',
        }
      },
      {
        path: 'scale_bag_allocation',         //量表(包)分配
        name: 'scale_bag_allocation',         //量表(包)分配
        component: resolve => require(['@/views/scale_bag_allocation/scale_bag_allocation'], resolve),
        meta: {
          title: '量表(包)分配',
          code:'scalePackage',
        }
      },
      {
        path: 'source_type_management',         //来源类型
        name: 'source_type_management',         //来源类型
        component: resolve => require(['@/views/source_type_management/source_type_management'], resolve),
        meta: {
          title: '来源类型',
          code:'source_type',
        }
      },
      {
        path: 'position_management',        //职位管理
        name: 'position_management',        //职位管理
        component: resolve => require(['@/views/position_management/position_management'], resolve),
        meta: {
          title: 'global.posts',
          code:'SYS_POSITION',
        }
      },
      {
        path: 'dict_management',            //字典管理
        name: 'dict_management',            //字典管理
        component: resolve => require(['@/views/dict_management/dict_management'], resolve),
        meta: {
          title: 'global.dict_type',
          code:'dict',
        }
      },
      {
        path: 'menu_management',            //菜单管理
        name: 'menu_management',            //菜单管理
        component: resolve => require(['@/views/menu_management/menu_management'], resolve),
        meta: {
          title: 'global.menus',
          code:'menu',
        }
      },
      {
        path: 'login_log',                 //登录日志
        name: 'login_log',                 //登录日志
        component: resolve => require(['@/views/login_log/login_log'], resolve),
        meta: {
          title: 'global.login_log',
          code:'loginLog',
        }
      },
      {
        path: 'business_log',             //业务日志
        name: 'business_log',             //业务日志
        component: resolve => require(['@/views/business_log/business_log'], resolve),
        meta: {
          title: 'global.business_log',
          code:'log',
        }
      },
      {
        path: 'notice_management',          //通知管理
        name: 'notice_management',          //通知管理
        component: resolve => require(['@/views/notice_management/notice_management'], resolve),
        meta: {
          title: 'global.messages',
          code:'notice',
        }
      },
      {
        path: 'tenant_management',           //租户管理
        name: 'tenant_management',           //租户管理
        component: resolve => require(['@/views/tenant_management/tenant_management'], resolve),
        meta: {
          title: 'global.tenants',
          code:'tenant_info',
        }
      },
      {
        path: 'label_manage',           // 量表标签管理
        name: 'label_manage',           // 量表标签管理
        component: resolve => require(['@/views/label_manage/label_manage'], resolve),
        meta: {
          title: 'global.label_manage',
        }
      },
      {
        path: '/',
        name: 'user_management',
        component: resolve => require(['@/views/user_management/user_management'], resolve),
        meta: {
          title: 'global.users',
          code:'mgr',
        }
      }
      ,
      {
        path: 'questionnaire_manage',           // 表单管理
        name: 'questionnaire_manage',           // 表单管理
        component: resolve => require(['@/views/questionnaire_management/questionnaire_manage'], resolve),
        meta: {
          title: 'global.questionnaire_manage',
        }
      },
      {
        path: 'edit_questionnaire',           // 表单创建
        name: 'edit_questionnaire',           // 表单创建
        component: resolve => require(['@/views/edit_questionnaire/edit_questionnaire'], resolve),
        meta: {

        }
      },
      {
        path: 'scale_report',           // 患者答题
        name: 'scale_report',           // 患者答题
        component: resolve => require(['@/views/questionnaire_answer_management/scale_report'], resolve),
        meta: {

        }
      },
      {
        path: 'package_report',           // 测评包答题
        name: 'package_report',           // 测评包答题
        component: resolve => require(['@/views/package_answer_management/package_report'], resolve),
        meta: {

        }
      },
      {
        path: 'scale_score',           // 试卷打分
        name: 'scale_score',           // 试卷打分
        component: resolve => require(['@/views/questionnaire_answer_management/scale_score'], resolve),
        meta: {

        }
      },
      {
        path: 'scale_conclusion',           // 查看结论
        name: 'scale_conclusion',           // 查看结论
        component: resolve => require(['@/views/questionnaire_answer_management/scale_conclusion'], resolve),
        meta: {

        }
      },
      {
        path: 'bag_conclusion',           // 查看测评包结论
        name: 'bag_conclusion',           // 查看测评包结论
        component: resolve => require(['@/views/package_answer_management/bag_conclusion'], resolve),
        meta: {

        }
      },
      {
        path: 'web_data_rocks',           // 透视图表
        name: 'web_data_rocks',           // 透视图表
        component: resolve => require(['@/views/webDataRocks/index'], resolve),
        meta: {

        }
      },
      {
        path: 'system_management',           // 这个是系统模块
        name: 'system_management',           // 这个是系统模块
        component: resolve => require(['@/views/system_management/system_management'], resolve),
        meta: {

        }
      },

    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/module/system_setting.js